@if ((corporateTaxEntity$ | async)) {
  <form (change)="saveForm()" [formGroup]="omschrijvingBedragFg">
    <div formArrayName="omschrijvingBedrag">
      @for (item of omschrijvingBedrag.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row mb-1">
            <div class="col-auto">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              [required]=true
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving-{{i}}"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control [label]="i === 0 ? 'Afschrijving' : ''"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150" formControlName="bedragAfschrijving"
                                                id="bedragAfschrijving-{{i}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control [label]="i === 0 ? 'Boekwaarde einde jaar' : ''"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150" formControlName="boekwaardeEindeBoekkjaar"
                                                id="boekwaardeEindeBoekkjaar-{{i}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-button
                (click)="verwijderRij(i)"
                [class]="i === 0 ? 'firstrowbutton' : ''"
                icon="trash"
                iconType="light"
                id="buttonDelete-{{i}}"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                       type="link">Bedrijfsmiddel toevoegen
  </snelstart-ui-button>
}

